import React from 'react';
import { Menu, Icon } from 'antd';

import common from '../assets/common.js'
import menuList from './menulist.js'

class MenuCon extends React.Component {
  constructor(props){
    super(props);
    const rootOpen = [];
    common.eachObj(menuList.list, function(index, dataItem){
      rootOpen.push(dataItem.key);
    });
    const menu = props.menu;
    const parents = common.lookUpParent(menuList.list, "sub", "key", menu)[0];
    if(parents) var openKey = parents[0]['key'];
    this.state = {
      collapsed : false,
      openKeys:[openKey],
      rootOpen
    }
  }
  componentWillReceiveProps(props){
    this.setState({ menu : props.menu})
  }
  onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
    if (this.state.rootOpen.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys });
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : [],
      });
    }
  }
  render(){
    const { menu, history } = this.props;
    const parents = common.lookUpParent(menuList.list, 'sub', 'key', menu)[0];
    const parent = parents[0];
    const showMenu = parent.key;
    return (
      <Menu
        id="mainMenu"
        className="scroll-bar-theme-r"
        theme="dark"
        mode="inline"
        defaultSelectedKeys={["menu" + showMenu]}
        selectedKeys={["menu" + showMenu]}
        onOpenChange={this.onOpenChange}
        style={{ lineHeight: '60px' }}
      >
        { menuList.list.map((dataItem, index) => {
            var toPage = "";
            if(parent.key === dataItem.key){
              toPage = function(){
                history.push( dataItem.key );
              }
            } else {
              toPage = function(){
                history.push( dataItem.key );
              }
            }
            const menuOne = <Menu.Item key={ "menu" + dataItem.key }>
              <a onClick={ toPage }>
                <Icon type={ dataItem.icon } />
                <span>{ dataItem.title }</span>
              </a>
            </Menu.Item>
            if(dataItem.hide){
              return "";
            } else {
              if(dataItem.authority.indexOf(window.info.adminRoles) > -1){
                return menuOne;
              } else {
                return ""
              }
            }
          })
        }
      </Menu>
    )
  }
}

export default MenuCon;



// WEBPACK FOOTER //
// ./src/index/menu.js